// src/modules/supplier/components/ProductListDisplay.js
import React from 'react';
import styled from 'styled-components';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { formatCurrency } from '../../utils/utils';

const ProductListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(2)};
`;

const ProductCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${props => props.theme.spacing(3)};
  background: ${props => props.theme.colors.surface};
  border-radius: ${props => props.theme.borderRadius};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s ease;

  &:hover {
    transform: translateX(4px);
  }
`;

const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(1)};
`;

const ProductName = styled.span`
  font-weight: ${props => props.theme.typography.fontWeight.medium};
  color: ${props => props.theme.colors.textPrimary};
`;

const ProductPrice = styled.span`
  color: ${props => props.theme.colors.textSecondary};
  font-size: ${props => props.theme.typography.fontSize.small};
`;

const ActionButtons = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(2)};
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: ${props => props.theme.colors.textSecondary};
  cursor: pointer;
  padding: ${props => props.theme.spacing(1)};
  transition: all 0.2s ease;
  
  &:hover {
    color: ${props => props.variant === 'delete' 
      ? props.theme.colors.error 
      : props.theme.colors.primary};
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;

const EmptyState = styled.div`
  text-align: center;
  padding: ${props => props.theme.spacing(4)};
  color: ${props => props.theme.colors.textSecondary};
  font-style: italic;
`;

const ProductListDisplay = ({ products, onEdit, onDelete }) => {
  if (!products?.length) {
    return <EmptyState>No products added yet</EmptyState>;
  }

  return (
    <ProductListContainer>
      {products.map((product, index) => (
        <ProductCard key={`${product.id}-${index}`}>
          <ProductInfo>
            <ProductName>{product.label}</ProductName>
            <ProductPrice>
              {formatCurrency(product.price)} per {product.unit}
            </ProductPrice>
          </ProductInfo>
          
          <ActionButtons>
            <ActionButton 
              onClick={() => onEdit(index)}
              title="Edit product"
            >
              <FaEdit />
            </ActionButton>
            <ActionButton 
              onClick={() => onDelete(index)}
              variant="delete"
              title="Remove product"
            >
              <FaTrash />
            </ActionButton>
          </ActionButtons>
        </ProductCard>
      ))}
    </ProductListContainer>
  );
};

export default ProductListDisplay;